import { Activity } from 'lucide-react';
import { InsightsDashboard } from './routes/dashboard.js';
/**
 * Модуль расхода токенов. Прав, кроме `llm.read` на вход, ему больше не нужно:
 * тумблеры настроек, ради которых модуль когда-то получил ещё и `llm.manage`,
 * переехали в единый раздел «Настройки».
 */
export const insightsModule = {
    id: 'insights',
    label: 'LLM',
    icon: Activity,
    permission: 'llm.read',
    workspace: 'system',
    order: 90,
    description: 'LLM usage dashboard — calls, token consumption, and per-task breakdown.',
    routes: [{ path: '/', component: InsightsDashboard }],
};
export { InsightsDashboard } from './routes/dashboard.js';
export { setInsightsApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map